import styled from 'styled-components';

export const StyledFooterContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 1rem 3rem;
    background-color: rgba(31, 44, 27, 0.2);
`

export const StyledFooterDivider = styled.div`
    width: 100%;
    border-top: 1px solid #FFF;
`

export const StyledFooterWrapper = styled.div`
    display: flex;
    flex-direction: row;

    @media (max-width: 768px) {
        flex-direction: column;

        h5 {
            text-align: center;
        }
    }
`

export const StyledFooterDescription = styled.div`
    display: flex;
    flex-direction: column;
    width: calc(100% / 3);

    @media (max-width: 768px) {
        width: 100%;
        align-items: center;

        p {
            text-align: center;
        }
    }
`

export const StyledFooterNav = styled.div`
    display: flex;
    gap: 0.5rem;
    flex-direction: column;
    width: calc(100% / 3);
    align-items: end;

    @media (max-width: 768px) {
        width: 100%;
        align-items: center;
        margin-bottom: 30px;
    }
`